import React from 'react';
import { FormattedMessage } from 'react-intl';
import InputMask from 'react-input-mask';
// Components
import { createInput, IInputProps } from '../InputHOC/InputHOC';

export class _Input extends React.Component<IInputProps> {
    render(): JSX.Element {
        const { label, mask, name, value, ...props } = this.props;

        return (
            <>
                {label && (
                    <label htmlFor={name}>
                        <FormattedMessage id={label} />
                    </label>
                )}

                {mask ? (
                    <InputMask mask={mask} maskChar=" " id={name} name={name} value={value || ''} {...props} />
                ) : (
                    <input id={name} name={name} value={value || ''} {...props} />
                )}
            </>
        );
    }
}

export const Input = createInput(_Input);
